import { Injectable, inject } from '@angular/core';
import { SiaHttpService } from '../services/http.service';
import { WalletPassRequest, WalletPassResult } from '../interfaces/wallet-pass';

/**
 * API client per gli endpoint POST `api/wallet-pass-proxy/{google|apple|generate}`
 * esposti dal modulo `Sia.WalletPass.Client` (proxy verso il manager remoto).
 *
 * La route e' `api/wallet-pass-proxy` (e non `api/wallet-pass`) per evitare collisioni
 * con il controller del manager, che nelle installazioni client (es. Sia.Access) e'
 * presente nel publish a causa della reference su `Sia.WalletPass` (riuso DTO).
 *
 * Tutti gli endpoint accettano lo stesso DTO `WalletPassRequest` e restituiscono
 * un `WalletPassResult` con campi popolati solo per i provider richiesti.
 */
@Injectable({ providedIn: 'root' })
export class WalletPassApi {
  private api = inject(SiaHttpService);

  private apiController: string = 'wallet-pass-proxy';

  /**
   * POST `api/wallet-pass-proxy/google` — genera solo il "Save to Google Wallet" link.
   * Popola `googleSaveLink` e `googleSaveButtonHtml`.
   */
  generateGoogle(request: WalletPassRequest): Promise<WalletPassResult> {
    return this.api.post(`${this.apiController}/google`, request);
  }

  /**
   * POST `api/wallet-pass-proxy/apple` — genera solo l'URL magic-link .pkpass.
   * Popola `applePkPassDownloadUrl`, `applePkPassFileName` e `applePkPassButtonHtml`.
   */
  generateApple(request: WalletPassRequest): Promise<WalletPassResult> {
    return this.api.post(`${this.apiController}/apple`, request);
  }

  /**
   * POST `api/wallet-pass-proxy/generate` — genera entrambi i wallet pass.
   * Popola tutti i campi disponibili in `WalletPassResult`.
   */
  generateBoth(request: WalletPassRequest): Promise<WalletPassResult> {
    return this.api.post(`${this.apiController}/generate`, request);
  }
}
